import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerStmtRezService } from '../owner-stmt-rez.service';
import { OwnerStmtRez } from '../owner-stmt-rez';
import { OwnerStmtRezComponent } from '../owner-stmt-rez/owner-stmt-rez.component';
import { ReservationService } from '@app/_components/reservation';
import { ReportService } from '@app/_components/report';
import { Table } from 'primeng/table';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PropertyService } from '@app/_components/property';

@Component({
    selector: 'app-owner-stmt-rez-list',
    templateUrl: './owner-stmt-rez-list.component.html',
    styleUrls: ['./owner-stmt-rez-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
  :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
      position: -webkit-sticky;
      position: sticky;
      top: 0px;
  }

  @media screen and (max-width: 64em) {
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
      }
  }
`],
    standalone: false
})
export class OwnerStmtRezListComponent implements OnInit, AfterViewInit {

	@ViewChild('pt') pt: Table;

  constructor(
		private ownerStmtRezService: OwnerStmtRezService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
	  	private dialog: MatDialog,
		private reportService: ReportService,
		private reservationService: ReservationService,
		private activatedRoute: ActivatedRoute,
		private propertyService: PropertyService,
	) {
		this.statuses = ownerStmtRezService.statuses
	}

  // data
  	@Input() ownerStmtId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;


	ownerStmtStartDate: Date | null = null;
	ownerStmtEndDate: Date | null = null;
	checkInDate: Date | null = null;
	checkOutDate: Date | null = null;
	ownerStmtsRez: any;
	ownerStmtRez: OwnerStmtRez;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ownerStmtRezId', header: 'Owner Stmt Rez Id', width: 'auto', showSort: true },
		{ field: 'reservationId', header: 'Rez Id', width: 'auto', showSort: true },
		{ field: 'ownerStmtVO.shortTermRentalId', header: 'Property Code', width: 'auto', showSort: true },
		{ field: 'ownerStmtVO.startDate', header: 'Start Date', width: 'auto', showSort: true },
		{ field: 'ownerStmtVO.endDate', header: 'End Date', width: 'auto', showSort: true },
		{ field: 'guestName', header: 'Guest Name', width: 'auto', showSort: true },
		{ field: 'checkInDate', header: 'CheckIn Date', width: 'auto', showSort: true },
		{ field: 'checkOutDate', header: 'CheckOut Date', width: 'auto', showSort: true },
		{ field: 'numNights', header: 'Total Nights', width: 'auto', showSort: true },
		{ field: 'paidNights', header: 'Paid Nights', width: 'auto', showSort: true },
		{ field: 'netRevenue', header: 'Net Revenue', width: 'auto', showSort: false },
		{ field: 'netRevenueTax', header: 'Net Revenue Tax', width: 'auto', showSort: false },
		{ field: 'mgntFee', header: 'Mgnt Fee', width: 'auto', showSort: false },
		{ field: 'mgntFeeTax', header: 'Mgnt Fee Tax', width: 'auto', showSort: false },
		{ field: 'stmtNightNetRevenue', header: 'Stmt Night Net Revenue', width: 'auto', showSort: false },
		{ field: 'stmtNightNetRevenueTax', header: 'Stmt Night Net Revenue Tax', width: 'auto', showSort: false }
	];

	openingReservation: { [key: number]: boolean } = {};
	shortTermRentals: any[] = [];
	selectedProperties: number[] = [];
	hasRouteParams = false;
	routeParamsApplied = false;

  ngOnInit(): void {
	console.log('ownerStmtId ownerStmtId ownerStmtId: ' + this.ownerStmtId);
	
	const params = this.activatedRoute.snapshot.queryParams;
	console.log('Route params in ngOnInit: ', params);
	
	if (params?.['shortTermRentalId'] || params?.['startDate'] || params?.['endDate'] || params?.['propertyCode']) {
		this.hasRouteParams = true;
	}
	
	this.loadShortTermRentals().then((success: boolean) => {
		this.loading = false;
		if(success) {
			if (this.hasRouteParams) {
				setTimeout(() => {
					if (this.pt) {
						this.applyInitialFilters();
					}
				}, 300);
			} else {
				this.loadLazy(this.lazyLoadEvent);
			}
		}
		else {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load properties', life: 3000 });
		}
	});
    try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}

	}

	ngAfterViewInit(): void {
		if (this.hasRouteParams && this.pt && this.shortTermRentals.length > 0) {
			setTimeout(() => {
				this.applyInitialFilters();
			}, 500);
		} else if (this.hasRouteParams) {
			setTimeout(() => {
				if (this.shortTermRentals.length > 0 && this.pt) {
					this.applyInitialFilters();
				}
			}, 1000);
		}
	}

	applyInitialFilters(): void {
		if (this.routeParamsApplied) {
			return;
		}

		const params = this.activatedRoute.snapshot.queryParams;
		
		if (!this.lazyLoadEvent) {
			this.lazyLoadEvent = {
				first: 0,
				rows: 25,
				filters: {}
			} as LazyLoadEvent;
		}

		if (!this.lazyLoadEvent.filters) {
			this.lazyLoadEvent.filters = {};
		}

		if (params?.['shortTermRentalId']) {
			const rentalId = Array.isArray(params['shortTermRentalId'])
				? params['shortTermRentalId'].map(id => parseInt(id, 10))
				: [parseInt(params['shortTermRentalId'], 10)];
			
			this.selectedProperties = rentalId;
			
			if (this.pt) {
				this.pt.filter(rentalId, 'ownerStmtVO.shortTermRentalId', 'in');
			}
			
			this.lazyLoadEvent.filters['ownerStmtVO.shortTermRentalId'] = {
				value: rentalId,
				matchMode: 'in'
			};
		}

		if (params?.['propertyCode'] && !params?.['shortTermRentalId']) {
			const property = this.shortTermRentals.find((p: any) => p.propertyCode === params['propertyCode']);
			if (property) {
				const rentalId = [property.shortTermRentalId];
				
				this.selectedProperties = rentalId;
				
				if (this.pt) {
					this.pt.filter(rentalId, 'ownerStmtVO.shortTermRentalId', 'in');
				}
				this.lazyLoadEvent.filters['ownerStmtVO.shortTermRentalId'] = {
					value: rentalId,
					matchMode: 'in'
				};
			}
		}

		if (params?.['startDate']) {
			const startDate = moment(params['startDate']).toDate();
			this.ownerStmtStartDate = startDate;
			const formattedDate = this.formatDateForFilter(startDate);
			
			if (this.pt) {
				this.pt.filter(formattedDate, 'ownerStmtVO.startDate', 'in');
			}
			
			this.lazyLoadEvent.filters['ownerStmtVO.startDate'] = {
				value: formattedDate,
				matchMode: 'in'
			};
		}

		if (params?.['endDate']) {
			const endDate = moment(params['endDate']).toDate();
			this.ownerStmtEndDate = endDate;
			const formattedDate = this.formatDateForFilter(endDate);
			
			if (this.pt) {
				this.pt.filter(formattedDate, 'ownerStmtVO.endDate', 'in');
			}
			
			this.lazyLoadEvent.filters['ownerStmtVO.endDate'] = {
				value: formattedDate,
				matchMode: 'in'
			};
		}

		this.routeParamsApplied = true;
		if (this.pt) {
			setTimeout(() => {
				if (!this.lazyLoadEvent.multiSortMeta || this.lazyLoadEvent.multiSortMeta.length === 0) {
					this.lazyLoadEvent.multiSortMeta = [];
					this.lazyLoadEvent.multiSortMeta.push({ field: 'createDate', order: 0 });
				}
				this.loadLazy(this.lazyLoadEvent);
			}, 200);
		}
	}
	

	loadShortTermRentals(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			this.loading = true;
			this.propertyService.propertySummaryIndividualPropertyList().subscribe(
				data => {
					this.shortTermRentals = data.data.properties;
					resolve(true);
				},
				error => {
					console.log('Error loading properties: ' + JSON.stringify(error));
					this.alertService.error(error);
					resolve(false);
				}
			);
		});
	}

	getPropertyCode(shortTermRentalId: number): string {
		const property = this.shortTermRentals.find((p: any) => p.shortTermRentalId === shortTermRentalId);
		return property ? property.propertyCode : `ID: ${shortTermRentalId}`;
	}

	getReconciliationRowClass(ownerStmtRez: any): string {
		if (ownerStmtRez == null) {
			return '';
		}
		const match = ownerStmtRez.match;
		if (match === true) {
			return 'reconcile-row-match-true';
		}
		if (match === false) {
			return 'reconcile-row-match-false';
		}
		return 'reconcile-row-match-null';
	}

  /*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerStmtRezId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

  /*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerStmtRez-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			if(this.ownerStmtId)
			{
				// show only ownerStmtRefunds that are assigned to this ownerStmtId
				let ownerStmtIdFilter = { 'ownerStmtId': { 'value': this.ownerStmtId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerStmtIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerStmtRezService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerStmtsRez = res.data.ownerStmtRezs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerStmtsRez = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerStmtRez: OwnerStmtRez) {
		try {
			this.formLoading = true;
			this.ownerStmtRezService.update(ownerStmtRez)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtsRez.map((ownerStmtRez, i) => {
							if (ownerStmtRez.ownerStmtRezId === res.data.ownerStmtRez.ownerStmtRezId) {
								this.ownerStmtsRez[i] = res.data.ownerStmtRez;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerStmtRez: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerStmtRez));

			this.formLoading = true;
			this.ownerStmtRezService.delete(ownerStmtRez.ownerStmtRezId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtsRez.splice(this.ownerStmtsRez.indexOf(ownerStmtRez), 1);
						this.recordTotal = this.ownerStmtsRez.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerStmtRez ' + ownerStmtRez.ownerStmtRezId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerStmtRez ' + ownerStmtRez.ownerStmtRezId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerStmtRez',
			ownerStmtId: this.ownerStmtId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtRezComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerStmtRezCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerStmtRez: OwnerStmtRez) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmtRez: ownerStmtRez,
			title: 'Edit OwnerStmtRez'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtRezComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerStmtRezCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerStmtRezCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerStmtRezCB(ownerStmtRez: OwnerStmtRez) {
		console.log('Adding OwnerStmtRez: ' + JSON.stringify(ownerStmtRez));
		// if we don't have a ownerStmtsRez array yet...
		if (!this.ownerStmtsRez) {
			this.ownerStmtsRez = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerStmtsRez.unshift(ownerStmtRez);

		// no idea what this is but it is required to update the array
		this.ownerStmtsRez = [...this.ownerStmtsRez];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtRez ' + ownerStmtRez.ownerStmtRezId + ' Added', life: 3000 });
	}

	updateOwnerStmtRezCB(ownerStmtRez: OwnerStmtRez) {
		console.log('Updating OwnerStmtRez: ' + JSON.stringify(ownerStmtRez));
		let itemIndex = this.ownerStmtsRez.findIndex((item: any) => item.ownerStmtRezId === ownerStmtRez.ownerStmtRezId);
		this.ownerStmtsRez[itemIndex] = ownerStmtRez;

		// no idea what this is but it is required to update the array
		this.ownerStmtsRez = [...this.ownerStmtsRez];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtRez ' + ownerStmtRez.ownerStmtRezId + ' Updated', life: 3000 });
	}

	deleteOwnerStmtRezCB(ownerStmtRez: OwnerStmtRez) {
		console.log('Removing OwnerStmtRez: ' + ownerStmtRez);
		this.ownerStmtsRez.splice(this.ownerStmtsRez.indexOf(ownerStmtRez), 1);
		this.recordTotal = this.ownerStmtsRez.length;

		// no idea what this is but it is required to update the array
		this.ownerStmtsRez = [...this.ownerStmtsRez];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtRez ' + ownerStmtRez.ownerStmtRezId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerStmtsRez ? this.first === (this.ownerStmtsRez.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerStmtsRez ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerStmtRez: any) {
		if (ownerStmtRez?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerStmtRez.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	onDateChange(date: Date | null,field: string) {
		this.pt.filter(
			date ? this.formatDateForFilter(date) : null,
			field,
			'in'
		);
	}

	openReservation(reservationId: number, event: any) {
		event.stopPropagation();
		this.openingReservation[reservationId] = true;
		this.reservationService.getOrderIdByReservationId(reservationId).subscribe(
			(res: any) => {
				window.open(`https://admin.kbmhawaii.com/order/${res?.data?.orderId}`, '_blank');
				this.openingReservation[reservationId] = false;
			},
			(err: any) => {
				console.log('Error fetching order ID: ' + JSON.stringify(err));
				this.openingReservation[reservationId] = false;
			}
		);
	}

	formatDateForFilter(date: Date | null): string | null {
		if (!date) {
			return null;
		}
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

}
